import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { Box, Typography, Button, Stack, Paper } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import BodyMapDialog from "../Assessments/ActiveCareTabs/CarePlan/Dialog/BodyMapDialog.js";
import BodyMapRecordsTable from "./BodyMapTable/BodyMapRecordsTable.js";
import { ArrowForwardIos, HealthAndSafety } from "@mui/icons-material";

const BodyMapScreen = () => {
  const { id: clientID } = useParams();
  const [dialogOpen, setDialogOpen] = useState(false);
  const [selectedData, setSelectedData] = useState(null);

  const handleAddButton = () => {
    setSelectedData(null);
    setDialogOpen(true);
  };

  return (
    <Box sx={{ p: { xs: 2, md: 4 }, bgcolor: "#f8fafc", minHeight: "100vh" }}>
      <Stack 
        direction={{ xs: "column", sm: "row" }} 
        justifyContent="space-between" 
        alignItems={{ xs: "flex-start", sm: "center" }} 
        spacing={2}
        sx={{ mb: 4 }}
      >
        <Box 
          sx={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: 2.5,
            mb: 0.5 
          }}
        >
          <Box 
            sx={{ 
              display: 'flex', 
              alignItems: 'center', 
              justifyContent: 'center',
              width: 54, 
              height: 54, 
              borderRadius: '16px', 
              bgcolor: 'rgba(37, 99, 235, 0.1)',
              color: '#2563eb',
              boxShadow: '0 0 20px rgba(37, 99, 235, 0.05)'
            }}
          >
            <HealthAndSafety sx={{ fontSize: 32 }} />
          </Box>

          <Box>
            <Stack direction="row" alignItems="center" spacing={1}>
              <Typography variant="h4" sx={{ fontWeight: 800, color: "#0f172a", letterSpacing: '-0.02em' }}>
                Body Map Assessment
              </Typography>
              <Box sx={{ 
                px: 1.5, py: 0.5, bgcolor: '#f1f5f9', borderRadius: '20px', 
                border: '1px solid #e2e8f0', display: { xs: 'none', md: 'block' } 
              }}>
                <Typography sx={{ fontSize: '0.75rem', fontWeight: 700, color: '#64748b', textTransform: 'uppercase' }}>
                  Clinical Tool
                </Typography>
              </Box>
            </Stack>
            
            <Stack direction="row" alignItems="center" spacing={1} sx={{ mt: 0.5 }}>
              <Typography variant="body1" sx={{ color: "#64748b", fontWeight: 500 }}>
                Track and manage physical observations
              </Typography>
              <ArrowForwardIos sx={{ fontSize: 12, color: "#cbd5e1" }} />
              <Typography variant="body1" sx={{ color: "#94a3b8", fontWeight: 400 }}>
                Injury Records
              </Typography>
            </Stack>
          </Box>
        </Box>
        
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={handleAddButton}
          sx={{ 
            bgcolor: "#2563eb",
            borderRadius: "12px", 
            textTransform: "none", 
            fontSize: "0.95rem",
            fontWeight: 600, 
            px: 4, 
            py: 1.2,
            boxShadow: "0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)",
            "&:hover": { bgcolor: "#1d4ed8", boxShadow: "none" } 
          }}
        >
          Add New Entry
        </Button>
      </Stack>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
        <Box sx={{ width: '100%' }}>
          <Paper 
            elevation={0} 
            sx={{ 
              borderRadius: "16px", 
              border: "1px solid #e2e8f0",
              overflow: "hidden",
              background: "#ffffff"
            }}
          >
            <Box sx={{ width: '100%' }}>
              <BodyMapRecordsTable clientID={clientID} /> 
            </Box>
          </Paper>
        </Box>
      </Box>

      <BodyMapDialog
        open={dialogOpen} 
        handleClose={() => { setDialogOpen(false); setSelectedData(null); }} 
        clientID={clientID} 
        initialData={selectedData} 
      />
    </Box>
  );
};

export default BodyMapScreen;